module.exports = __webpack_public_path__ + "static/media/paymentButton.7e5ae8f2.svg";